import React, { useCallback } from "react";
import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import { Form, FormItem, Input, Password, Submit } from "@formily/antd";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import * as ICONS from "@ant-design/icons";
import CodeInput from "../VerifyCode/CodeInput";
import styles from "./index.module.less";

const normalSchema = {
  type: "object",
  properties: {
    username: {
      type: "string",
      title: "用户名",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        prefix: "{{icon('UserOutlined')}}",
        placeholder: "请输入账号",
      },
    },
    code: {
      type: "string",
      title: "验证码",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "CodeInput",
      "x-component-props": {
        placeholder: "请输入验证码",
        token: "{{{token}}}",
      },
      "x-reactions": [
        {
          dependencies: [".phone#value", ".phone#valid"],
          fulfill: {
            state: {
              "component[1].readyPost": "{{$deps[0] && $deps[1]}}",
              "component[1].phoneNumber": "{{$deps[0]}}",
            },
          },
        },
      ],
    },
    password: {
      type: "string",
      title: "密码",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Password",
      "x-component-props": {
        prefix: "{{icon('LockOutlined')}}",
        placeholder: "请输入密码",
      },
    },
  },
};
const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    Password,
    CodeInput,
  },
  scope: {
    icon(name) {
      return React.createElement(ICONS[name]);
    },
  },
});
function ResetPassword() {
  const loading = useSelector((state) => state.loading.effects.user.login);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const normalForm = createForm({
    validateFirst: true,
  });
  const loginHandler = useCallback(
    async (value) => {
      const url = await dispatch.user.login(value);
      if (url) navigate(url);
    },
    [dispatch, navigate]
  );

  return (
    <div className={styles.resetPasswordContainer}>
      <div className="header">甘肃省政务信息报送系统</div>
      <div className="body">
        <div className="form-container">
          <Form
            form={normalForm}
            layout="vertical"
            size="large"
            onAutoSubmit={loginHandler}
          >
            <SchemaField schema={normalSchema} />
            <Submit block size="large" loading={loading}>
              重置密码
            </Submit>
          </Form>
          <div className="extra">
            <Link to="/">登录</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ResetPassword;
